<template>
  <div id="continuing" v-loading="loading">
    <div class="tree_left">
      <tree
        :props="{ label: 'name', children: 'areas' }"
        :data="cameraList"
        :expanded="expanded"
        :camera="camera"
        @handleNodeClick="location"
        ref="region"
      ></tree>
    </div>

    <div class="statistics">
      <section class="device">
        <header>视频监控</header>
        <div v-if="videoType" class="content">
          <videoPlayer :videoUrl="videoUrl" v-if="videoUrl"></videoPlayer>
          <div v-else class="noVideo">暂无视频</div>
        </div>
        <div v-else class="content">
          <img v-default-img style="width: 100%; height: 100%" v-if="imgUrl" :src="imgUrl" alt="" />
          <div v-else class="noVideo">暂无图片</div>
        </div>
      </section>
    </div>

    <div class="message_gj">
      <gjjl ref="gjjl"></gjjl>
    </div>
  </div>
</template>

<script>
  import { drawCghc } from './tongji.js'
  export default {
    data() {
      return {
        //tree
        cameraList: [],
        expanded: [],
        loading: false,
        camera: true,
        cameraId: 0,
        //统计
        areaId: 0,
        onlineCount: 0,
        alarmCount: 0,
        offlineCount: 0,
        deviceCount: 0,
        troubleCount: 0,
        //设备列表选项
        devices: [{ id: 0, typeName: '全部' }],
        active: 0,
        //amap
        markers: [],
        itemId: 0,
        b_showWindow: true,
        icon: '',
        mapData: [],
        videoUrl: '',
        imgUrl: '',
        videoType: true
      }
    },
    components: {
      tree: () => import('public/regionTree/tree'),
      gjjl: () => import('./gjjl'),
      videoPlayer: () => import('./video')
    },
    methods: {
      //el-tree
      getTreeData() {
        this.cameraList = []
        this.$axiosget('operation/devics/cameraList').then(res => {
          res.data.data.forEach(e => {
            this.cameraList.push({
              id: e.id,
              name: e.deviceName
            })
          })
        })
      },
      location(data) {
        //console.log(data, "视频");
        // this.cameraId = data.id;
        this.videoUrl = ''
        this.$refs.gjjl.gjjl(data.id)
        this.$axiosget('operation/configuration/findByDeviceId', {
          params: {
            deviceId: data.id
          }
        }).then(res => {
          if (res.data.data.type === '2') {
            this.imgUrl = res.data.data.imgUrl
            this.videoType = false
          } else {
            this.videoUrl = res.data.data.video_url
            var ipAddr = window.location.href
            console.log(' ---------- ' + ipAddr)
            if (0 > ipAddr.indexOf('192.168')) {
              // 如果是vpn环境
              // 改为vpn摄像头访问的地址
              if (res.data.data != null && res.data.data.standby_video_url != null) {
                this.videoUrl = res.data.data.standby_video_url
              }
            }
            this.videoType = true
          }
        })
      },
      tabDevices(i, id, icon) {
        this.active = i
        this.itemId = id
        this.icon = icon
        this.location()
      },
      drawCghc(index, data, bg, color) {
        drawCghc.call(this, index, data, bg, color)
      }
    },
    mounted() {
      this.getTreeData()
    }
  }
</script>

<style scoped lang="less">
  #continuing {
    display: flex;
    width: 100%;
    height: 100%;
    padding-top: 20px;
    background: #0c111b;

    .region {
      overflow-y: auto;
      height: 100%;
    }
  }

  .statistics {
    margin: 0 20px;
    width: 55%;
    height: 100%;
    // overflow-y: scroll;
  }

  .statistics > section {
    background: rgba(24, 28, 46, 0.9);
    border: 2px solid #263046;
    padding-bottom: 25px;
    height: 100%;
  }

  .statistics > section > header {
    height: 39px;
    background-color: #253253;
    line-height: 39px;
    color: #fff;
    font-size: 16px;
    padding: 0 20px;
    border-top: 1px solid #35b9f7;
  }

  .statistics .content {
    padding: 0 20px;
    // height: 100%;
  }
  .noVideo {
    color: #ccc;
    text-align: center;
    margin-top: 50px;
  }

  .message_gj {
    width: 25%;
    height: 100%;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/camera/index.vue